/* eslint-disable arrow-body-style */
/* eslint-disable no-else-return */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Center from '../../assets/styles/Center';
import EditContainer from '../../assets/styles/EditContainer';
import Text from '../../assets/styles/Text';
import FormAuth from '../../components/FormAuth';
import Loader from '../../components/Loader';
import Title from '../../components/Title';
import AboutsService from '../../services/AboutsService';
import ModelService from '../../services/ModelService';
import { useStore } from '../../stores';
import * as styles from './styles';

export default function ModelAbout() {
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [abouts, setAbouts] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});

  const { id } = useStore((state) => state.user);

  useEffect(() => {
    async function loadAbouts() {
      try {
        setLoading(true);

        const { gender } = await ModelService.findById(id);

        const aboutsService = await AboutsService.listAbouts(gender);

        setAbouts(aboutsService);
      } catch (error) {
        toast.error('Erro ao carregar cidades');
      } finally {
        setLoading(false);
      }
    }

    loadAbouts();
  }, [id]);

  useEffect(() => {
    async function loadExistingModelAbouts() {
      if (abouts.length === 0) return;

      try {
        setLoading(true);

        const existingData = await AboutsService.getModelAbouts();

        if (existingData && existingData.length > 0) {
          const formattedData = {};

          existingData.forEach((item) => {
            formattedData[item.aboutId] = item.content;
          });

          setSelectedValues(formattedData);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }

    loadExistingModelAbouts();
  }, [abouts]);

  const handleChange = (aboutId, value, isMultiple = false) => {
    setSelectedValues((prev) => {
      if (isMultiple) {
        const currentValue = prev[aboutId] || '';
        const currentArray = currentValue ? currentValue.split(', ') : [];

        if (currentArray.includes(value)) {
          const newArray = currentArray.filter((item) => item !== value);
          return {
            ...prev,
            [aboutId]: newArray.length > 0 ? newArray.join(', ') : undefined,
          };
        } else {
          const newArray = [...currentArray, value];
          return {
            ...prev,
            [aboutId]: newArray.join(', '),
          };
        }
      } else {
        // Para campos únicos
        return {
          ...prev,
          [aboutId]: value,
        };
      }
    });
  };

  const hasValue = (aboutId) => {
    const value = selectedValues[aboutId];
    return value !== undefined && value !== null && value !== '';
  };

  const isOptionSelected = (aboutId, value) => {
    const currentValue = selectedValues[aboutId];
    if (typeof currentValue === 'string' && currentValue.includes(',')) {
      const currentArray = currentValue.split(', ');
      return currentArray.includes(value);
    }
    // Para campos únicos
    return currentValue === value;
  };

  const handleRemove = async (aboutId) => {
    try {
      setSelectedValues((prev) => {
        const newValues = { ...prev };
        delete newValues[aboutId];
        return newValues;
      });

      await AboutsService.deleteModelAbout(aboutId);

      toast.success('Informação removida com sucesso!');
    } catch (error) {}
  };

  async function onSubmit() {
    try {
      setSubmitting(true);

      const entries = Object.entries(selectedValues);
      const itemsToUpdate = [];
      const itemsToRemove = [];

      entries.forEach(([aboutId, content]) => {
        if (content === '' || !content || content.trim() === '') {
          itemsToRemove.push(aboutId);
        } else {
          itemsToUpdate.push({ aboutId, content });
        }
      });

      for (const aboutId of itemsToRemove) {
        await AboutsService.deleteModelAbout(aboutId);
      }

      if (itemsToUpdate.length > 0) {
        await AboutsService.upsertModelAboutBatch(itemsToUpdate);
      }

      toast.success('Filtros salvos com sucesso!');
    } catch (error) {
      toast.error('Erro ao atualizar filtros');
    } finally {
      setSubmitting(false);
    }
  }

  const renderField = (filter) => {
    const choices = filter.choices.split(',').map((choice) => choice.trim());
    const isContentField =
      choices.length === 1 && choices[0].toLowerCase() === 'content';
    const isMultiple = filter.multiple;

    if (isContentField) {
      // Campo de texto livre
      return (
        <styles.Content key="content">
          <input
            type="number"
            placeholder="Digite sua resposta"
            value={selectedValues[filter.id] || ''}
            onChange={(e) => handleChange(filter.id, e.target.value)}
          />
        </styles.Content>
      );
    }

    if (isMultiple) {
      // Múltiplas seleções - checkboxes
      return choices.map((choice) => (
        <styles.Bubble
          htmlFor={`${filter.id}-${choice}`}
          key={choice}
          $checked={isOptionSelected(filter.id, choice)}
        >
          <input
            type="checkbox"
            id={`${filter.id}-${choice}`}
            value={choice}
            checked={isOptionSelected(filter.id, choice)}
            onChange={() => handleChange(filter.id, choice, true)}
            hidden
          />
          <Text.Span>{choice}</Text.Span>
        </styles.Bubble>
      ));
    } else {
      // Seleção única - radio buttons
      return choices.map((choice) => (
        <styles.Bubble
          htmlFor={`${filter.id}-${choice}`}
          key={choice}
          $checked={isOptionSelected(filter.id, choice)}
        >
          <input
            type="radio"
            id={`${filter.id}-${choice}`}
            name={`filter-${filter.id}`}
            value={choice}
            checked={selectedValues[filter.id] === choice}
            onChange={() => handleChange(filter.id, choice)}
            hidden
          />
          <Text.Span>{choice}</Text.Span>
        </styles.Bubble>
      ));
    }
  };

  if (loading) return <Loader isLoading={loading} />;

  return (
    <EditContainer>
      <Center className="center">
        <Title
          title="Atualize suas informações"
          subtitle="Adicione sobre seu atendimento e sobre você"
        />

        <FormAuth
          buttonTitle={submitting ? 'Salvando...' : 'Continuar'}
          next
          twoButtons
          isLoading={submitting}
          onSubmit={onSubmit}
          formValid={!submitting}
          disabled={submitting}
        >
          <styles.Group>
            <styles.Collumn>
              <Text.H4 $upper $bold>
                Sobre Você
              </Text.H4>
              {abouts
                ?.filter((filter) => filter.group === 'about')
                ?.map((filter) => (
                  <styles.GroupInput key={filter.id}>
                    <label>{filter.name}</label>

                    {selectedValues[filter.id] && (
                      <styles.Selected>
                        <Text.Span>
                          Selecionado: {selectedValues[filter.id]}
                        </Text.Span>
                      </styles.Selected>
                    )}

                    {renderField(filter)}

                    {filter.choices !== 'content' && hasValue(filter.id) && (
                      <styles.ButtonRemove
                        type="button"
                        onClick={() => handleRemove(filter.id)}
                        title="Remover informação"
                      >
                        <Text.Span>Limpar seleção</Text.Span>
                      </styles.ButtonRemove>
                    )}
                  </styles.GroupInput>
                ))}
            </styles.Collumn>

            <styles.Collumn>
              <Text.H4 $upper $bold>
                Serviço
              </Text.H4>
              {abouts
                ?.filter((filter) => filter.group === 'treatment')
                ?.map((filter) => (
                  <styles.GroupInput key={filter.id}>
                    <label>{filter.name}</label>

                    {selectedValues[filter.id] && (
                      <styles.Selected>
                        <Text.Span>
                          Selecionado: {selectedValues[filter.id]}
                        </Text.Span>
                      </styles.Selected>
                    )}

                    {renderField(filter)}

                    {hasValue(filter.id) && (
                      <styles.ButtonRemove
                        type="button"
                        onClick={() => handleRemove(filter.id)}
                        title="Remover informação"
                      >
                        <Text.Span>Limpar seleção</Text.Span>
                      </styles.ButtonRemove>
                    )}
                  </styles.GroupInput>
                ))}
            </styles.Collumn>
          </styles.Group>
        </FormAuth>
      </Center>
    </EditContainer>
  );
}
